import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import logo from './logo.svg';
import Hamburger from '../hamburger/Hamburger';
import styles from './Nav.css';

class Nav extends Component {
  static propTypes = {
    activeItem: PropTypes.string,
    onLangChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      opened: false,
      justClosed: false,
      anim: true,
      isVisible: true,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ anim: false });
    setTimeout(() => this.setState({
      opened: !this.state.opened,
      justClosed: this.state.opened,
      anim: true,
    }), 100);
  }

  toEn() {
    this.toLang('en');
  }

  toCht() {
    this.toLang('cht');
  }

  toLang(lang) {
    const { onLangChange } = this.props;
    localStorage.setItem('lang', lang);
    if (this.state.opened) {
      this.handleClick()
    }
    if (onLangChange) {
      onLangChange();
    }
  }

  onChange(isVisible) {
    if (isVisible !== this.state.isVisible) {
      this.setState({
        isVisible: isVisible,
        justClosed: false,
      });
    }
  }

  render() {
    const { opened, justClosed, anim, isVisible } = this.state;
    const { activeItem } = this.props;
    const navClass = classnames(
      styles.nav,
      { [styles.open]: opened },
      { 'animated fadeIn': anim },
      { 'fadeOutUp': !isVisible },
      { 'fadeInDown': isVisible && !opened && !justClosed },
    );
    const navProjects = classnames(styles.navItem, { [styles.navActiveItem]: activeItem === 'projects' });
    const navInfo = classnames(styles.navItem, { [styles.navActiveItem]: activeItem === 'info' });
    const navContact = classnames(styles.navItem, { [styles.navActiveItem]: activeItem === 'contact' });
    const navJournal = classnames(styles.navItem, { [styles.navActiveItem]: activeItem === 'journal' });
    const navLangSwitch = classnames(styles.navItem, styles.navLangSwitch);

    return (
      <div>
        <VisibilitySensor
          onChange={this.onChange.bind(this)}
          partialVisibility={true}
          offset={{ top: -250 }}
        />
        <nav className={navClass}>
          <section className="container">
            <div className="row">
              <div className="col--s-4of12">
                <Link to="/"><img src={logo} alt="logo" /></Link>
                <Hamburger
                  handleClick={this.handleClick}
                  opened={opened} />
              </div>
              <div className="col--s-5of12 col--s-offset-3of12">
                <ul className={styles.navList}>
                  <li className={navProjects}><Link to="/projects/tags">Projects</Link></li>
                  <li className={navInfo}><Link to="/about">About</Link></li>
                  <li className={navJournal}><Link to="/journal">Journal</Link></li>
                  <li className={navContact}><Link to="/contact">Contact</Link></li>
                  <li className={navLangSwitch}>
                    <span onClick={this.toEn.bind(this)} className={styles.switchLang}>EN</span>&nbsp;/&nbsp;
                    <span onClick={this.toCht.bind(this)} className={styles.switchLang}>中</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </nav>
      </div>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js